import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map, take, tap } from 'rxjs/operators';
import { AgentService } from '../services/agent.service';
import { logDebug, logWarn, logError } from '../core/services/logger.service';

/**
 * Guard to prevent agents from accessing certain routes
 * Redirects agents to /agent-dashboard page
 */
export const nonAgentGuard: CanActivateFn = (route, state) => {
  const agentService = inject(AgentService);
  const router = inject(Router);

  return agentService.verifyAgentAccess().pipe(
    take(1),
    map(({ isAgent }) => {
      if (isAgent) {
        // User is an agent, redirect to agent-dashboard page
        router.navigate(['/agent-dashboard']);
        return false;
      }

      // Not an agent, allow access
      logDebug('[NonAgentGuard] Access granted to dashboard');
      return true;
    })
  );
};
